export class Employment {
    id: string;
    employer: string;
    fromDate: string | Date;
    toDate: string | Date;
    position: string;
    noExperience: boolean;
}
